
import React, { useState } from 'react';
import { callApi } from './api';

function CreateUserForm({ onUserCreated, createFunction = 'createUserV2', contextualAdminUid, onCancel }) {
  // Standard fields
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  
  // New fields for Level 1 users
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [unit, setUnit] = useState('');
  const [parking, setParking] = useState('');

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const isLevel1User = createFunction === 'createUserV2';

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const userData = {
      email,
      password,
      displayName,
    };

    if (isLevel1User) {
      Object.assign(userData, { phone, address, unit, parking });
    }

    if (contextualAdminUid) {
      userData.adminUid = contextualAdminUid;
    }

    try {
      await callApi(createFunction, userData);
      
      if(onUserCreated) onUserCreated();

    } catch (err) {
      setError('Kunne ikke opprette bruker. ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleCreateUser} style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '5px', margin: '20px auto', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
      <h3>Opprett ny bruker</h3>

      <div>
        <label htmlFor="create-email" style={{ display: 'block', marginBottom: '5px' }}>E-post</label>
        <input
          id="create-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="off"
          required
        />
      </div>

      <div>
        <label htmlFor="create-password" style={{ display: 'block', marginBottom: '5px' }}>Passord</label>
        <input
          id="create-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
      </div>

      <div>
        <label htmlFor="create-displayName" style={{ display: 'block', marginBottom: '5px' }}>Fullt navn</label>
        <input
          id="create-displayName"
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          required
        />
      </div>

      {isLevel1User && (
        <>
          <div>
            <label htmlFor="create-phone" style={{ display: 'block', marginBottom: '5px' }}>Telefonnummer</label>
            <input id="create-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          <div>
            <label htmlFor="create-address" style={{ display: 'block', marginBottom: '5px' }}>Adresse</label>
            <input id="create-address" type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
          </div>
          <div>
            <label htmlFor="create-unit" style={{ display: 'block', marginBottom: '5px' }}>Boenhet / Leilighetsnr.</label>
            <input id="create-unit" type="text" value={unit} onChange={(e) => setUnit(e.target.value)} />
          </div>
          <div>
            <label htmlFor="create-parking" style={{ display: 'block', marginBottom: '5px' }}>Parkeringsplass</label>
            <input id="create-parking" type="text" value={parking} onChange={(e) => setParking(e.target.value)} />
          </div>
        </>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        <button type="button" onClick={onCancel}>Avbryt</button>
        <button type="submit" disabled={loading}>
          {loading ? 'Oppretter...' : 'Opprett bruker'}
        </button>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
}

export default CreateUserForm;
